import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_comp_branch_location_entity_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  object_type: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  location_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_line_guid: fromDatatype.GuidDataFieldInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  default_arap_type: fromDatatype.VarcharDatatypeInterface;
  entity_approval_rank: fromDatatype.IntegerDatatypeInterface;
  customer_code: fromDatatype.VarcharDatatypeInterface;
  supplier_code: fromDatatype.VarcharDatatypeInterface;
  employee_code: fromDatatype.VarcharDatatypeInterface;
  merchant_code: fromDatatype.VarcharDatatypeInterface;
  credit_limit_status: fromDatatype.VarcharDatatypeInterface;
  credit_term_status: fromDatatype.VarcharDatatypeInterface;
}


export class bl_fi_mst_comp_branch_location_entity_link_RowCLass implements bl_fi_mst_comp_branch_location_entity_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  object_type: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  location_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_line_guid: fromDatatype.GuidDataFieldInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  default_arap_type: fromDatatype.VarcharDatatypeInterface;
  entity_approval_rank: fromDatatype.IntegerDatatypeInterface;
  customer_code: fromDatatype.VarcharDatatypeInterface;
  supplier_code: fromDatatype.VarcharDatatypeInterface;
  employee_code: fromDatatype.VarcharDatatypeInterface;
  merchant_code: fromDatatype.VarcharDatatypeInterface;
  credit_limit_status: fromDatatype.VarcharDatatypeInterface;
  credit_term_status: fromDatatype.VarcharDatatypeInterface;
}
